import * as _ from "lodash";
import {BaseAccountOverviewView, BaseAccountView} from "../_BaseAccountViews";
import {
    BaseTeamDetailView, TeamNotificationView, TeamPermissionView, TeamSettingsView,
    TeamUsersView
} from "./TeamDetailViews";
import * as Backbone from "backbone";
import {PermissionCollection} from "../../../collections/Permissions";


export class TeamOverviewView extends BaseAccountOverviewView {

    protected subViews: BaseTeamDetailView[] = [];

    private currentUserGroup: Backbone.Model;
    private userGroupPermissionCollection: PermissionCollection = null;

    private currentSubDetail = null;
    private currentSubDetailId = null;

    show(groupId, detail?, subDetail?, subDetailId?) {
        this.currentDetail = detail;
        this.currentSubDetail = subDetail;
        this.currentSubDetailId = subDetailId;

        this.currentUserGroup = this.options.userGroupCollection.findWhere({id: Number(groupId)});
        this.userGroupPermissionCollection = new PermissionCollection([], {
            userGroupId: Number(groupId)
        });

        $.when(this.userGroupPermissionCollection.getCollectionFetchPromise()).done(() => {
            this.collectionLoaded = true;
            this.render();

            // If there is a detail render it exclusively
            if (detail) {
                return $.when(this.renderSubViews(detail, false)).done(() => {
                    this.showBreadcrumbs();
                });
            }

            // Otherwise render all details
           return $.when.apply($, _.map([
               'settings', 'users', 'permissions', 'notifications'
           ], (viewClass) => {
                return this.renderSubViews(viewClass, true);
            })).done(() => {
                // Breadcrumbs may depend on subviews. Render them after they have been instantiated
                this.showBreadcrumbs();
            });
        });
    }

    render() {
        this.$el.html(this.template({
            collectionLoaded: this.collectionLoaded,
            title: this.currentUserGroup ? this.currentUserGroup.get('name') : '',
            canView: true
        }));

        (<any> this.$('input[type="checkbox"]')).bootstrapToggle();
        this.delegateEvents();
        return this;
    }

    showBreadcrumbs() {
        if (!this.options.currentOrganizationId || !this.currentUserGroup) return;
        var orgId = this.options.currentOrganizationId;
        var teamId = this.currentUserGroup.get('id');

        var routeString = '/#/account/' + this.options.currentOrganizationId + '/teams/' + teamId;
        this.breadcrumbPathMap = {
            [this.currentOrganization.get('name')]: '/#/account/' + orgId,
            'Teams': '/#/account/' + this.options.currentOrganizationId + '/teams'
        };

        var currentPath, searchByX;
        if (this.currentDetail) {
            this.breadcrumbPathMap[this.currentUserGroup.get('name')] = routeString;

            var subview = _.first(this.subViews);
            if(this.currentSubDetail && subview) {
                this.breadcrumbPathMap[_.capitalize(this.currentDetail)] = routeString + '/' + this.currentDetail;

                var details = subview.getBreadcrumbDetails(this.breadcrumbPathMap);
                searchByX = details.searchByX;
                this.breadcrumbDropDownOptions = details.dropDownOptions;
                currentPath = details.currentPath;
            } else {
                searchByX = 'Team Details';
                this.breadcrumbDropDownOptions = {
                    'Settings': routeString + '/settings',
                    'Users': routeString + '/users',
                    'Permissions': routeString + '/permissions',
                    'Notifications': routeString + '/notifications',
                };
                currentPath = _.capitalize(this.currentDetail);
            }
        } else {
            searchByX = 'Team';
            currentPath = this.currentUserGroup.get('name');
            this.options.userGroupCollection.each((uGroup) => {
                this.breadcrumbDropDownOptions[uGroup.get('name')] = '/#/account/' + orgId + '/teams/' + uGroup.get('id');
            }, this);
        }

        super.showBreadcrumbs(currentPath, searchByX);
    }

    renderSubViews(detail, isOverview) {
        var options = {
            currentUserGroup: this.currentUserGroup,
            userGroupPermissionCollection: this.userGroupPermissionCollection,
            isOverview: isOverview
        };

        var subview;
        switch (detail) {
            case 'settings':
                subview = new TeamSettingsView(_.extend({}, this.options, options));
                break;
            case 'users':
                subview = new TeamUsersView(_.extend({}, this.options, options));
                break;
            case 'permissions':
                subview = new TeamPermissionView(_.extend({}, this.options, options));
                break;
            case 'notifications':
                subview = new TeamNotificationView(_.extend({}, this.options, options));
                break;
        }

        if (subview) {
            this.subViews.push(subview);
            this.$('.container').append(subview.render().$el);
            return subview.show(this.currentSubDetail, this.currentSubDetailId);
        }
    }
}


// WEBPACK FOOTER //
// ./srv/public/js/views/account/team/TeamOverviewView.ts